import React from "react";

import { Button } from "@/components/ui/Button";

/**
 * One toggle in the usage toolbar's segmented control — a date preset, or
 * "All time".
 *
 * `aria-pressed` is what tells a screen reader which window is selected; the
 * tone is the same fact for everyone else.
 */
const UsageChip = ({ active, disabled, title, onClick, children }) => (
  <Button
    title={title}
    disabled={disabled}
    onClick={onClick}
    aria-pressed={active}
    // The selected window is a state a reader must see from across the page,
    // so the active chip carries a tone rather than a slightly lighter grey.
    className={`rounded-md px-2.5 py-1 text-xs font-medium transition-colors disabled:opacity-60 ${
      active ? "bg-tone-blue-soft text-tone-blue ring-1 ring-tone-blue/40" : "text-text-secondary hover:bg-background-tertiary hover:text-text-primary"
    }`}
  >
    {children}
  </Button>
);

export default UsageChip;
